<template>
    <label class="input-switch">{{ labelText }}
        <input
            type="checkbox"
            :checked="checked || false"
            @click="() => onClick(checked)"
        />
        <span class="switch-button"></span>
    </label>
</template>

<script>
export default {
  props: {
    labelText: String,
    checked: Boolean
  },
  methods: {
    _emitOnClickEvent(checked) {
      this.$emit('onClick', checked);
    },
    onClick(checked) {
      this._emitOnClickEvent(!checked);
    }
  }
}
</script>